
import heroImage2 from './../assets/images/heroImage2.webp';
import heroImage3 from './../assets/images/heroImage3.webp';
import heroImage5 from './../assets/images/heroImage5.webp';
import heroImage6 from './../assets/images/heroImage6.webp';
import heroImage8 from './../assets/images/heroImage8.webp';
import heroImage9 from './../assets/images/heroImage9.webp';
import heroImage10 from './../assets/images/heroImage10.webp';
import heroImage12 from './../assets/images/heroImage12.webp';

import slideImageHomeBannerOne from './../assets/images/thumbnail_RO_Web_Homepage_Banner_SLIDE-1.webp';
import slideImageHomeBannerTwo from './../assets/images/thumbnail_RO_Web_Homepage_Banner_SLIDE-2.webp';
import slideImageHomeBannerThree from './../assets/images/thumbnail_RO_Web_Homepage_Banner_SLIDE-3.webp';

const imagesPool = [
    { src: heroImage2, isUs: false, eager: true },
    { src: heroImage3, isUs: false },
    { src: heroImage5, isUs: false },
    { src: heroImage6, isUs: false },
    { src: heroImage8, isUs: true },
    { src: heroImage9, isCa: true },
    { src: heroImage10, isCa: true },
    { src: heroImage12, isUs: false },


    { src: slideImageHomeBannerOne, isUk: true },
    { src: slideImageHomeBannerTwo, isUk: true },
    { src: slideImageHomeBannerThree, isUk: true },
];

export default imagesPool;